import { useEffect } from 'react';

/**
 * Компонент для добавления JSON-LD разметки в head документа
 * @param {Object} data - Объект с данными для JSON-LD
 * @param {string} id - Уникальный идентификатор скрипта (для возможности обновления)
 */
const JsonLd = ({ data, id = 'json-ld' }) => {
    useEffect(() => {
        if (!data) return;

        // Удаляем старый скрипт, если он существует
        const existingScript = document.getElementById(id);
        if (existingScript) {
            existingScript.remove();
        }

        // Создаем новый script элемент с JSON-LD
        const script = document.createElement('script');
        script.id = id;
        script.type = 'application/ld+json';
        script.text = JSON.stringify(data);
        document.head.appendChild(script);

        // Очистка при размонтировании
        return () => {
            const scriptToRemove = document.getElementById(id);
            if (scriptToRemove) {
                scriptToRemove.remove();
            }
        };
    }, [data, id]);

    return null;
};

export default JsonLd;

